import {
	apiPost,
	apiDelete,
	apiGet,
	apiPut
} from './api';

// 分页查询店铺自定义商品分类
export const queryCustomizeLabelPage = (data) => {
	return apiPost('/ecommerce/customizeLabel/queryPage', data);
};

// 新增/修改店铺自定义商品分类
export const createOrUpdateCustomizeLabel = (data) => {
	return apiPost('/ecommerce/customizeLabel/createOrUpdate', data);
};

// 批量删除店铺自定义商品分类
export const removeCustomizeLabel = (data) => {
	const {
		customizeLabelIdList = []
	} = data || {};
	const queryParams = customizeLabelIdList
		.map(id => `customizeLabelIdList=${encodeURIComponent(id)}`)
		.join('&');
	const url = `/ecommerce/customizeLabel/remove?${queryParams}`;
	return apiDelete(url);
};

//查询商品类型
export const getGoodsTypeList = (data) => {
	return apiPost('/ecommerce/goods/queryGoodsTypePage', data);
};
// 分页查询商品列表信息
export const getGoodsList = (data) => {
	return apiPost('/ecommerce/goods/queryPromoGoodsPage', data);
};
// 删除商品
export const deleteGoods = (data) => {
	const {
		promoGoodsIdList = []
	} = data;
	const queryParams = promoGoodsIdList.map(id => `promoGoodsIdList=${id}`).join('&');
	const url = `/ecommerce/goods/removePromoGoodsInfo?${queryParams}`;
	return apiDelete(url);
};
// 批量下架商品
export const delistPromoGoodsBatch = (data) => {
	const {
		promoGoodsIdList = []
	} = data;
	const queryParams = promoGoodsIdList.map(id => `promoGoodsIdList=${id}`).join('&');
	const url = `/ecommerce/goods/delistPromoGoodsBatch?${queryParams}`;
	return apiPut(url);
};
//新增/更新商品
export const newGoods = (data) => {
	return apiPost('/ecommerce/goods/cuPromoGoodsPage', data);
};
//顾客评价
export const remark = (data) => {
	return apiPost('/ecommerce/order/reply/query', data);
};

//商家回复
export const createOrderReply = (data) => {
	return apiPost('/ecommerce/order/reply/create', data);
};

//商品详情
export const goodsDetail = (data) => {
	return apiGet('/ecommerce/goods/getPromoGoodsInfoDetail', data)
}
